<template>
    <div
        ref="el"
        class="w-full m-0"
    >
        <div
            v-if="direction == 'prev'"
            class="btn-group flex-nowrap flex justify-center w-full"
        >
            <button
                class="btn btn-sm h-12"
                @click="selectPage(page)"
            >
                {{ $t('product.listing.prevProducts') }}
                <span v-if="loading" class="loading loading-spinner" />
            </button>
        </div>

        <div
            v-else-if="direction == 'next' && !loading"
            class="btn-group flex-nowrap flex justify-center w-full"
        >
            <button
                class="btn btn-sm h-12"
                @click="selectPage(page)"
            >
                {{ $t('product.listing.nextProducts') }}
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
interface ProductListingPaginationProps {
    page: number
    direction: string
    loading?: boolean
}

const props = withDefaults(defineProps<ProductListingPaginationProps>(), {
    loading: false
})

const emit = defineEmits<{
    (event: 'loadPage', page: number): void
}>()

function selectPage(page: number): void {
    if (!props.loading) {
        emit('loadPage', page)
    }
}

const el = ref()
const observer = ref()

onMounted(() => {
    if (props.direction === 'next') {
        const options = {
            threshold: 0,
            rootMargin: '400px'
        }
        observer.value = new IntersectionObserver(function (entries) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    selectPage(props.page)
                }
            })
        }, options)

        observer.value?.observe(el.value)
    }
})

onUnmounted(() => {
    if (observer.value != null) {
        observer.value?.disconnect()
    }
})
</script>
